
  
<script>
import Layout from "../../layouts/main";
import ZoneComponent from "@/router/views/zone/zone-component.vue";
import AddPartnerByZone from "@/router/views/zone/add-partners-zone-component.vue";
import SettingsCampaign from "@/components/SettingsCampaign";
import SettingsQrCampaign from "@/components/SettingsQrCampaign";
import CampaignApi from "@/services/campaign-api";
import vue2Dropzone from "vue2-dropzone";
import PartnerApi from "@/services/partner-api";
import Swal from "sweetalert2";
import GiftSetting from "@/router/views/gift/gift";

export default {
    name: 'campaign',
    components: {Layout, ZoneComponent, SettingsCampaign, SettingsQrCampaign, vue2Dropzone, AddPartnerByZone, GiftSetting},

    props:{
     campaignId :{
            type:Number,
            default: null
        },
    },
    data() {
      return {
        campaign: {id:null ,
                    sector:[],
                    country:null ,
                    cityList:[], 
                    nearList:null, },

      selectedPartnerList:[],
      zoneKey:0,
      dropzoneOptions: {
        url: "/",
        addRemoveLinks: true,
        autoProcessQueue:false,
        maxFiles: 1,
        },
      multiDropzoneOptions: {
        url: "/",
        addRemoveLinks: true,
        autoProcessQueue:false,
        maxFiles: 10,
        },
        partnerFilter:null,
        partnersList:[],
        partnersTableBusy:false,
        editSelectionStaring:false,
        showOnlySelected:false,
        pageModelPartnerList: {currentPage : 1, perPage :10, totalRows: 0},
        imagesMap: {}, 
        vediosMap: {}, 

        selectedPartnersFields: [
            { key:"selection",label:"",thClass:"text-center align-middle", tdClass:"text-left align-middle"},
            { key:"companyName", label: "", sortable: false,thClass:"text-left" , tdClass:" font-size-14 p-2 text-left align-middle"},
            { key:"ownerName", label: "", sortable: false,thClass:"text-left" , tdClass:"font-size-12 text-left align-middle"},
            { key:"purchasingPower", label: "", sortable: false,thClass:"text-center" , tdClass:"text-center align-middle"},
            { key:"phone", label: "", sortable: false,thClass:"text-left" , tdClass:"text-left align-middle"},
            { key:"shortAddress", label:"", thClass:"text-left", tdClass:"text-left align-middle", thStyle:"min-width:150px;"}, 
            { key:"sector", label: "", sortable: false,thClass:"text-left", tdClass:"text-left font-weight-bold  align-middle"},
            { key:"gps", label: "", sortable: false,thClass:"text-center" , tdClass:"text-center font-weight-bold  align-middle", thStyle:"min-width:140px;"},
        ],
      };
    },

    mounted() {
      this.campaign.id = this.campaignId ?  this.campaignId : null
      this.findDetailsCampainById()
      this.getSelectedPartners()

    },

    watch:{
        showOnlySelected:function(){
            if(!this.showOnlySelected){
                this.pageModelPartnerList= {currentPage : 1, perPage :10, totalRows: 0}
            }
            this.getSelectedPartners()
        }
    },

    methods: {

    handleRefresh() {
        this.findDetailsCampainById()
    },


    findMediaByCode(code , isImage) {
        CampaignApi.findMediaByCode(code).then((result)=>{
            if(result){
                if(isImage){
                    this.$set(this.imagesMap, code , result );
                }else{
                    this.$set(this.vediosMap, code , result );
                }
            }
        });
        },
    

    getSelectedPartners(){
    this.partnersTableBusy = true

    PartnerApi.getSelectedPartners(this.pageModelPartnerList.currentPage, this.pageModelPartnerList.perPage, this.partnerFilter, this.campaignId, this.showOnlySelected).then(result => {
        if (result) {
            this.partnersList = result.partnerResponseDTO.list;
            this.pageModelPartnerList.totalRows = result.partnerResponseDTO.total;
            this.pageModelPartnerList.currentPage = result.partnerResponseDTO.page;
            this.pageModelPartnerList.perPage = result.partnerResponseDTO.pageSize;
            this.pageModelPartnerList.pageSize = result.partnerResponseDTO.pageSize;
            this.partnersTableBusy = false

        }else{
            this.partnersList = [];
            this.pageModelPartnerList= {currentPage : 1, perPage :10, totalRows: 0}

        }
    }).catch(() => {
        this.partnersTableBusy = false
    })
    .finally(()=>{
        this.partnersTableBusy = false
    });
    }, 


    editSelection(partner){
        this.partnersTableBusy = true

        if(partner == null){
            return;
        }
        
        this.editSelectionStaring=true
        PartnerApi.editSelection(this.pageModelPartnerList.currentPage, this.pageModelPartnerList.perPage, this.partnerFilter, this.campaignId, partner.id, this.showOnlySelected).then((result)=>{
                if(result){
                    this.partnersList = result.partnerResponseDTO.list;
                    this.pageModelPartnerList.totalRows = result.partnerResponseDTO.total;
                    this.pageModelPartnerList.currentPage = result.partnerResponseDTO.page;
                    this.pageModelPartnerList.perPage = result.partnerResponseDTO.pageSize;
                    this.pageModelPartnerList.pageSize = result.partnerResponseDTO.pageSize;
                    this.partnersTableBusy = false
                    this.editSelectionStaring = false
                }
            }
        ).catch(() => {
          this.partnersTableBusy = false
          this.editSelectionStaring = false
        })
        .finally(()=>{
            this.partnersTableBusy = false
            this.editSelectionStaring = false
            this.findDetailsCampainById()
        });
    },

    deleteMedia(mediaName){
        CampaignApi.deleteMedia(this.campaign.id, mediaName).then(result =>{
            if(result){
                this.campaign = result
                this.selectedCity = this.campaign.cityDTOS	
                this.selectedCountry = this.campaign.countryDTO	
                this.selectedOptions = this.campaign.partnerNearsList	

            }
        }).finally(()=>{
            this.refreshMedia(this.campaign)
        })
    },


    refreshMedia(campaign){
        this.vediosMap = {}
        this.imagesMap = {}

        if(campaign.imagesCampaign){
            campaign.imagesCampaign.forEach(im=>{
                this.findMediaByCode(im, true)
            })
        }

        if(campaign.videoCampaign){
            campaign.videoCampaign.forEach(im=>{
                this.findMediaByCode(im, false)
            })
        }
    },

    findDetailsCampainById(){
        if(this.campaign == null || this.campaign.id == null){
            return
        }

        CampaignApi.findDetailsCampainById(this.campaign.id).then(result =>{
            if(result){
                this.campaign = result
                this.selectedCity = this.campaign.cityDTOS	
                this.selectedCountry = this.campaign.countryDTO	
                this.selectedOptions = this.campaign.partnerNearsList	

                this.refreshMedia(this.campaign)


            }
        })
        },

    saveMultiVueDropzone() {
        const formData = new FormData();
        const multiVueDropzone = this.$refs.multiVueDropzone.getAcceptedFiles();

        if (multiVueDropzone && multiVueDropzone.length > 0) {
            multiVueDropzone.forEach((file) => {  formData.append('medias', file);});
            formData.append('isBagsModel', false);
            this.uploaldMedia(formData)
        }

    },

    saveBagModelDropzone(){
        const formData = new FormData();
        formData.append('isBagsModel', true);

        const bagModelDropzone=this.$refs.bagModelDropzone.getAcceptedFiles()[0]
        if (bagModelDropzone) {
            formData.append('medias', bagModelDropzone);
            this.uploaldMedia(formData)
        }
        
    },

    uploaldMedia(formData){

        formData.append('campaignId', this.campaignId);
        CampaignApi.saveMedia(formData).then(result =>{
            if(result){
                this.campaign = result
                this.selectedCity = this.campaign.cityDTOS	
                this.selectedCountry = this.campaign.countryDTO	
                this.selectedOptions = this.campaign.partnerNearsList	
                this.$refs.multiVueDropzone.removeAllFiles();
                this.$refs.bagModelDropzone.removeAllFiles();

            }
        }).finally(()=>{
            this.refreshMedia(this.campaign)
        })
    },


    refreshId(id){
      this.campaign.id = id
      this.findDetailsCampainById()
    },

    filterdPartnerName(idList){
        if(idList == null || idList.length == 0){
            return
        }
        
      Swal.fire({
              title: this.$t('campaign.addManuelPartner'),
              html: this.$t('campaign.addManuelPartnerConfirmation', { count: idList.length , companyName :this.campaign.name }),
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#d11010",
              confirmButtonText: "Oui, Enregistrer",
              cancelButtonText: "Annuler",
            }).then((result) => {
              if (result.value) {
                CampaignApi.addManualPartner(idList.join(","), this.campaign.id ).then(result =>{
                    if(result){
                        this.campaign = result
                        this.zoneKey++
                        this.findDetailsCampainById()
                        this.getSelectedPartners()
                    }
                })
              }
            });
    },

    filteredMarkers(selectedPartnerList , country , cityList , nearList, sector , latitude ,longitude , radius){
        this.selectedPartnerList = selectedPartnerList
        this.campaign.country = country
        this.campaign.cityList = cityList
        this.campaign.nearList = nearList
        this.campaign.sector = sector
        this.campaign.latitude = latitude
        this.campaign.longitude = longitude
        this.campaign.radius = radius

    },

    saveZoneCampain(){

        const zoneCampaign = {
            id : this.campaign.id,
            countryId: this.campaign.country == null ? null : this.campaign.country.id ,
            cityList: this.campaign.cityList == null ? null : this.campaign.cityList.map(city => city.id),
            nearList: this.campaign.nearList == null ? null : this.campaign.nearList.map(near => near.code),
            sectorList: this.campaign.sector == null ? null : this.campaign.sector.map(sector => sector.code),
            latitude: this.campaign.sector == null ? null : this.campaign.latitude,
            longitude: this.campaign.longitude == null ? null : this.campaign.longitude,
            radius: this.campaign.radius == null ? null : this.campaign.radius
        }

        CampaignApi.saveZoneCampain(zoneCampaign).then(result =>{
            if(result){
                this.campaign = result
                this.zoneKey++
                this.findDetailsCampainById()
                this.getSelectedPartners()
            }
        })
    },

 
  },


    
  };
  </script>

<template>
    <Layout>

     <!-- Header -->

     <div v-if="campaign" class="row pt-0 pr-sm-5 pl-sm-5 pr-2 pl-2 text-md-left text-center  ">
        <div class="col-md-6 col-12">
          <h1 class="text-primary font-weight-bold text-uppercase">
            {{campaign && campaign.name ? campaign.name : ''}} 
          </h1>

          <h5 class="text-dark font-weight-bold text-uppercase font-size-20">
            {{ campaign.customerName }}
          </h5>



        </div>

        <div class="col-md-6 col-12 text-md-right text-center mt-4 mt-md-0">

            <h5 v-if="campaign && campaign.quantityBagAsString" class="text-dark font-size-16"> 
            <strong>{{campaign.quantityBagAsString}}</strong> {{ $t('campaign.bagsOrdered') }}
          </h5>


            <h5 v-if="campaign && campaign.start && campaign.end"  class="text-dark font-size-14">
            <strong>{{ campaign.start }}</strong>  {{ $t('periode.end') }} <strong>{{ campaign.end }}</strong>

          </h5>

            <router-link v-if="campaign && campaign.id" class="mr-2" :to="{ path: '/campaign/planification', query: { campaignId: campaign.id }}">
                <b-button  title="Ouvrir"  size="sm"  class="bg-light" variant="outline-primary" >
                    <img class="align-middle mr-2" alt="Delivery" width="20px" src="@/assets/icons/delivery.svg" style="cursor: pointer;" :title="$t('campaign.delivery.planification')" />
                      <span class="d-none font-weight-bold d-xl-inline text-primary text-uppercase">{{ $t('campaign.deliveryPlanningGeneral') }}</span>
                </b-button> 
            </router-link>

            <router-link v-if="campaign && campaign.id" class="ml-2" :to="{ path: '/campaign/etat', query: { campaignId: campaign.id }}">
                <b-button  title="Ouvrir"  size="sm"  class="bg-light" variant="outline-primary" >
                    <img class="text-primary align-middle mr-2" alt="Edit" width="20px" src="@/assets/icons/status.svg" style="cursor: pointer;" :title="$t('campaign.delivery.status')" />
                      <span class="d-none font-weight-bold d-xl-inline text-primary text-uppercase">{{ $t('campaign.distributionState') }}</span>
                </b-button> 
            </router-link>


                

         
        </div>

        
      </div>
      <!-- End Header -->

    <div class="row pt-4 pl-sm-5 pr-sm-5 pr-2 pl-2">
        <div class="col-lg-6 pr-md-4 pr-0 ">
            <div class="card h-100 w-100" style="border: 1px solid rgb(221, 221, 221);">
                <div class="card-body ">
                  <SettingsCampaign :campaign="campaign" @refreshId="refreshId" ></SettingsCampaign>
                </div>
            </div>
        </div>

        <div class="col-lg-6 pl-md-4 pl-0 mt-md-0 mt-5">

            <div class="card h-100 w-100" style="border: 1px solid rgb(221, 221, 221);">
                <div class="card-body" :style="campaign.id && !campaign.campaignWithOutBags  ? '':'opacity:0.5'">
                    <div class="row">
                        <div class="col-8">
                            <h2 class="card-title font-size-25 text-uppercase text-dark" style="font-size:25px;">{{$t('campaign.card.imageModel')}} </h2>
                        </div>

                        <div class="col-4">
                            <b-button variant="primary" @click="saveBagModelDropzone" class="float-sm-right text-uppercase font-weight-bold mt-2 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="campaign.id == null">
                                {{$t("buttons.import")}}
                            </b-button> 
                        </div>

                    </div>
                        <!-- <div class="text-primary text-uppercase font-size-16 pt-3 pb-2 "> {{$t('campaign.label.imageModel')}} </div> -->

                        <div class="row my-auto h-100 pb-md-0 pb-4 ">
                            <div class="text-center pr-2 my-auto" :class="campaign && campaign.bagsModel ? 'col-md-6' : 'col-md-12'">
                                <b-form-group class="text-dark font-weight-bold" :label="$t('campaign.text.bannerType')" label-for="" :disabled="campaignId == null  || campaign.campaignWithOutBags "  >
                                    <vue2Dropzone class="m-0 p-0 m-md-2 p-md-1" id="bagModelDropzone" ref="bagModelDropzone" maxFileSizeInMB="1" maxNumberOfFiles="1" :use-custom-slot="true" :options="dropzoneOptions">
                                        <div class="dropzone-custom-content text-center p-3">
                                        <img   alt=""  width="80px"  src="@/assets/icons/cloud-upload.svg"  />  
                                            <h4 class="mb-0">{{ $t('parameters.dropImage') }}</h4>
                                            <h5 class="text-warning font-size-9 text-Center mt-1" >{{ $t('parameters.imageSize') }} </h5>
                                        </div>
                                    </vue2Dropzone>
                                </b-form-group>     
                            </div>
                            <div v-if="campaign && campaign.bagsModel" class="col-12 col-md-6 pl-2 mt-4 my-auto">
                                <img  v-if="campaign && campaign.bagsModel" alt=""  width="100%" height="auto"  v-bind:src="'/api/image/get/' + campaign.bagsModel"  />  
                            </div>
                        </div>
                       
                </div>
            </div>
        </div>

        

        
    </div>

    <div class="row mt-4 pr-sm-5 pl-sm-5 mt-5 pr-2 pl-2">
        <div class="col-lg-12">
            <div class="card" style="border: 1px solid rgb(221, 221, 221);">
                <div class="card-body" :style="campaign.id && !campaign.campaignWithOutBags  ? '':'opacity:0.5'">

                    <div class="row">
                        <div class="col-8">
                            <h2 class="card-title font-size-25 text-uppercase text-dark" style="font-size:25px;">{{$t('campaign.card.zone')}} </h2>
                        </div>
                        <div class="col-4">
                            <b-button variant="primary" @click="saveZoneCampain" class="float-sm-right text-uppercase font-weight-bold mt-2 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="campaign.id == null || campaign.campaignWithOutBags ">
                                    {{$t("buttons.save")}}
                            </b-button> 
                        </div>
                    </div>
                    <!-- <div class="text-primary text-uppercase font-size-16 pt-3 pb-2 "> {{$t('campaign.label.zone')}} </div> -->

                    <ZoneComponent :key="zoneKey" :campaign="this.campaign" :fromMenu="false" :sector="this.campaign.sector" 
                                @filteredMarkers="filteredMarkers" 
                                @select-change="saveZoneCampain"
                                class="mb-4"></ZoneComponent>
                    
                        
                </div>
            </div>
        </div>
    </div>  


    <div class="row mt-4 pr-sm-5 pl-sm-5 mt-5 pr-2 pl-2">
        <div class="col-lg-12">
            <div class="card" style="border: 1px solid rgb(221, 221, 221);">
                <div class="card-body" :style="campaign.id && !campaign.campaignWithOutBags  ? '':'opacity:0.5'">

                    <h2 class="card-title font-size-25 text-uppercase text-dark mb-3" style="font-size:25px;">{{ $t('campaign.selectedPartner.title') }}</h2>

                    <AddPartnerByZone :sector="this.campaign.sector" @filterdPartnerName="filterdPartnerName"  />

                    <div class="form-group text-right m-0 mt-5" >
                        <b-form-checkbox
                        :value="true"
                        :unchecked-value="false"
                        v-model="showOnlySelected"
                        class="custom-checkbox custom-checkbox-success mb-0 mt-0 font-size-14"
                        ><span :class="showOnlySelected? 'text-success' : ''"> {{ $t("campaign.selectedPartner.showOnlySelected") }}</span> </b-form-checkbox>
                    </div>
                        
                    <b-form-group :label="$t('campaign.input.partnerFilter')" class="col-lg-12 col-md-12 col-12 mt-3 " >
                        <b-input-group  >
                            <b-form-input :placeholder="$t('campaign.label.partnerFilter')"   v-model="partnerFilter"   @keyup.native.enter="getSelectedPartners() "
                                ></b-form-input>                              
                            <template v-slot:append>
                                <b-button variant="danger" @click="getSelectedPartners()" >
                                <i class="bx bx-search-alt font-weight-bold font-size-16  align-middle"></i>
                                </b-button>
                            </template>
                        </b-input-group>
                    </b-form-group>

                    <span v-if="!partnersTableBusy & !partnersList.length" class="d-flex justify-content-center m-4 text-danger" > {{$t('campaign.selectedPartner.table.empty')}} </span>
                        <div v-else class="table-responsive mt-4" style="max-height: 40em;min-height: 35em;" > 
                                <b-table 
                                :busy="partnersTableBusy"
                                :striped="true"
                                :small="true"
                                :hover="true"
                                :items="partnersList"
                                :fields="selectedPartnersFields"
                                :perPage="pageModelPartnerList.perPage"
                                class="table"
                                id="my-table"
                                >
                                    <template v-slot:table-busy>
                                        <div class="text-center my-2">
                                            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                        </div>
                                    </template>

                                    <template v-slot:head(gps)>
                                        {{ $t("partner.table.head.gps") }} 
                                    </template>
                                    <template v-slot:head(companyName)>
                                        {{ $t("partner.table.head.namePartner") }} 
                                    </template>
                                    <template v-slot:head(ownerName)>
                                        {{ $t("partner.table.head.ownerName") }} 
                                    </template>
                                    <template v-slot:head(sector)>
                                        {{ $t("partner.table.head.sector") }} 
                                    </template>
                                    <template v-slot:head(shortAddress)>
                                        {{ $t("partner.table.head.shortAddress") }} 
                                    </template>
                                    <template v-slot:head(dayOffAsString)>
                                        {{ $t("partner.table.head.dayOf") }} 
                                    </template>
                                    <template v-slot:head(phone)>
                                        {{ $t("partner.table.head.phone") }} 
                                    </template>
                                    <template v-slot:head(purchasingPower)>
                                        {{ $t("partner.table.head.purchasingPower") }} 
                                    </template>
                                    <template v-slot:head(active)>
                                        {{ $t("partner.table.head.active") }} 
                                    </template>

                                    <template v-slot:cell(purchasingPower)="{ value }">
                                        <b-badge v-if="value && value > 0" href="#" :variant="value <= 3 ? 'danger' : value > 3 && value <= 6 ? 'success' : 'primary'" class="font-size-12 font-weight-bold pr-2 pl-2">
                                            {{ value }}
                                        </b-badge>
                                        <div v-else>-</div>
                                    </template>
                                    <template v-slot:cell(phone)="{item}">
                                        <div>{{item.phone1}}  {{ item.phone2 ? ("/"+ item.phone2 ): "" }}</div>
                                    </template>
                                    <template v-slot:cell(companyName)="{item}">
                                        <div class="text-uppercase font-weight-bold">{{item.companyName}} </div>
                                        <div class="text-secondary font-size-12 mt-1">{{item.address}} </div>
                                    </template>
                                    <template v-slot:cell(dayOffAsString)="{value}">
                                        <div>{{value ? value  : "-"}}</div>
                                    </template>

                                    <template v-slot:cell(shortAddress)="{item}">
                                        <div>{{item.countryName}} - {{ item.cityName }}</div>
                                    </template>
                                    <template v-slot:cell(gps)="{item}">
                                        <code>{{item.latitude}} - {{ item.longitude }}</code>
                                    </template>

                                    <template v-slot:cell(selection)="{item}">
                                    <b-form-checkbox
                                        value="1"
                                        unchecked-value="0"
                                        class="custom-checkbox-success "
                                        v-model="item.selection"
                                        @input="editSelection(item)"
                                        :disabled="editSelectionStaring || !(campaign.id && !campaign.campaignWithOutBags)"
                                        ></b-form-checkbox>
                                    </template>
                                </b-table>
                        </div>
                    <!-- Pagination -->
                    <div class="row pt-3 mb-sm-4">
                        <div class="col-sm-8">
                            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                <b-form-select @input="getSelectedPartners()"  v-model="pageModelPartnerList.perPage" size="sm" style="width: 60px" :options="[10,15,20]"></b-form-select>
                                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pageModelPartnerList.totalRows}} {{ $t("pagination.lines") }}</span></div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                <b-pagination v-model="pageModelPartnerList.currentPage" :disabled="partnersTableBusy" :per-page="pageModelPartnerList.pageSize" :total-rows="pageModelPartnerList.totalRows" @input="getSelectedPartners()" ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div> 
                    <!-- Fin Pagination  -->

                    
                        
                </div>
            </div>
        </div>
    </div>  




    <div class="row mt-4 pr-sm-5 pl-sm-5 mt-5 pr-2 pl-2">
        <div class="col-lg-12">    
            <SettingsQrCampaign :campaign="this.campaign" @refreshCampaign="handleRefresh" ></SettingsQrCampaign>
        </div>
    </div>

    <div class="row mt-4 pr-sm-5 pl-sm-5 mt-5 pr-2 pl-2">
        <div class="col-lg-12">    
            <div class="card">

                <div class="card ">
                <div class="card-body " :style="campaign.id ? '':'opacity:0.5'">
                    <GiftSetting :campaign="this.campaign"/>
                 </div>
            </div>  
            </div>
        </div>
    </div>


        <div class="row mt-4 pr-sm-5 pl-sm-5 mt-5 pr-2 pl-2">
        <div class="col-lg-12">    
            <div class="card">

                <div class="card-body" :style="campaign.id && !campaign.campaignWithOutBags  ? '':'opacity:0.5'">

                    <div class="row">
                        <div class="col-8">
                            <h2 class="card-title font-size-25 text-uppercase text-dark" style="font-size:25px;">{{$t('campaign.card.imageVisite')}} </h2>

                        </div>
                        <div class="col-4">
                            <b-button v-if="this.campaign" variant="primary" @click="saveMultiVueDropzone" class="float-sm-right font-weight-bold text-uppercase mt-4 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="campaign.id == null  || campaign.campaignWithOutBags">
                                {{$t("buttons.import")}}
                            </b-button> 
                        </div>
                    </div>

                        <!-- <div class="text-primary text-uppercase font-size-16 pt-3 pb-2 "> {{$t('campaign.label.imageVisite')}} </div> -->

                        <div class="col-12 text-center mt-5">
                            <b-form-group class="text-dark font-weight-bold" :label="$t('campaign.text.bannerImageVideoType')" label-for="" :disabled="campaignId == null  || campaign.campaignWithOutBags"  >
                                <vue2Dropzone class="m-0 p-0 m-md-2 p-md-1" id="multiVueDropzone" ref="multiVueDropzone" maxFileSizeInMB="1" maxNumberOfFiles="10" :use-custom-slot="true" :options="multiDropzoneOptions">
                                    <div class="dropzone-custom-content text-center p-3">
                                    <img   alt=""  width="80px"  src="@/assets/icons/cloud-upload.svg"  />  
                                        <h4 class="mb-0">{{ $t('parameters.dropImage') }}</h4>
                                        <h5 class="text-warning font-size-9 text-Center mt-1" >{{ $t('parameters.imageSize') }} </h5>
                                    </div>
                                </vue2Dropzone>
                            </b-form-group>     
                        </div>

                        <!-- <h2 class="card-title font-size-25" style="font-size:25px;">{{$t('campaign.card.galleryMedias')}} </h2> -->


                        <div v-if="this.campaign && this.campaign.imagesCampaign" class="row gallery mt-3">
                            <div class="gallery-images" v-for="(image, code) in imagesMap" :key="code">
                                <div class="media-container">
                                    <img class="media-image" alt="" :src="image" />
                                    <img alt="Delete media" class="delete-media" width="40px" src="@/assets/icons/trash.svg" style="cursor: pointer;" @click="deleteMedia(code)" />
                                </div>
                            </div>
                        </div>
                        <div class="row gallery  mt-3">
                        <div class="gallery-images"  v-for="(vedio, code) in vediosMap" :key="code">
                            <div class="media-container">
                            <video class="media-image" loop playsinline autoplay muted >
                                <source :src="vedio" type="video/mp4" >
                            </video>	
                            <img alt="Delete media" class="delete-media" width="40px" src="@/assets/icons/trash.svg" style="cursor: pointer;" @click="deleteMedia(code)"/>

                            </div>
                        </div>
                        </div>


                       
                </div>
            </div>
        </div>
    </div>

    </Layout>
</template>


<style scoped>
.gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.gallery-images {
  flex: 1 1 calc(25% - 10px);
  box-sizing: border-box;
  position: relative;
}

.media-container {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 280px;
}
.media-image {
  max-width: 250px;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: filter 0.3s ease;
  position: relative;
  z-index: 1;
}

.delete-media {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
}

.media-container:hover .media-image {
  filter: blur(2px);
}

.media-container:hover .delete-media {
  opacity: 0.8;
}

@media (max-width: 768px) {
  .gallery-images {
    flex: 1 1 calc(50% - 10px);
  }
}

@media (max-width: 480px) {
  .gallery-images {
    flex: 1 1 100%;
  }
}

</style>